module.exports = __webpack_public_path__ + "img/help_05.00f2fb61.png";